import { BuildCredentialingEmailHtml } from '../../constants/api.config'
import getCharts from '../getCharts'

export default async function BuildCredentialingEmailHtmlApi(payload = {}) {
    console.log('BuildCredentialingEmailHtmlApi payload:', payload)
    try {
        const res = await getCharts(BuildCredentialingEmailHtml, payload)
        return res.data
    } catch (error) {
        return error
    }
}
